<template>
    <span :class="`badge ${colorClass ? `badge-${colorClass}` : ''} badge-icon`" :style="`background-color: ${resolved.badgeColor}; color: ${resolved.textColor}`">
        <i :class="icon"  :style="`background-color: ${resolved.iconColor}`" aria-hidden="true"></i>
        <span>
            {{ $t(label) }}
            <template v-if="addon">
                <i class="fas fa-angle-right"></i>{{ addon }}
            </template>
        </span></span>
</template>

<script>
  import { badgeColors } from '../StatusBadge'

  export default {
    name: 'StatusBadge',
    props: {
      colorClass: String,
      icon: String,
      label: [Object, String],
      addon: {},
      color: String,
    },
    computed: {
      resolved() {
        return this.color ? badgeColors(this.color) : {};
      }
    }
  }
</script>

<style scoped>

</style>
